import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getMaterailReqList = createAsyncThunk("/getMaterailReqList", async (data, { rejectWithValue }) => {
//   const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}materialRequest/api/v1/search-list`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Material Request List response", response);
    return response?.data; // returns { success, message, Total, data } 
  } catch (error) {
    console.error("Error fetching Material Request", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Raw Material");
  }
});
